<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/spain')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/spain/ribera-del-duero/pingus')">Pingus</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/spain/ribera-del-duero/vega-sicilia')">Vega Sicilia</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/spain')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Ribera del Duero</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Una di queste regioni è Ribera del Duero, situata nel nord del paese. Trovato in Castilla y Leon, a circa due ore a nord di Madrid, la regione è lunga circa 70 miglia e corre lungo il fiume Duero. Ha anche un terreno sorprendentemente semi-arido mentre le enormi differenze di altitudine, terreno, esposizione e, naturalmente, savoir faire non fanno di due vini uguali. È stata anche nominata Regione dell'anno da Wine Enthusiast nel 2012.
                        <br><br>
                        Prendiamo ad esempio i suoi due protagonisti: Pingus è considerato uno dei vini più individuali sul mercato. La sua singolarità è la sua forza e non sarebbe stata possibile in una delle altre regioni vinicole della Spagna. I vini Tempranillo della vecchia vite sono grandi, audaci e strutturati e sono trattati con sensibilità e amore dall'enologo di Pingus Peter Sisseck, che ha puntato i riflettori sulla regione. E sì, è un Pingus è uno dei puntatori perfetti di Parker.
                        <br><br>
                        L'altra superstar della regione è completamente diversa, sottolineando la grande varietà che ha
                        Ribera del Duero è capace di. Unico di Vegas Sicilia ha mantenuto il tradizionalismo del vecchio mondo che
                        ne ha fatto un attore mondiale da oltre 150 anni. Le sue proporzioni epiche sono illimitate, offrendo
                        potenziale di cantina senza pari, sia che tu stia cercando di bere o investire. Entrambi i vini sono a
                        essere risparmiato per una giornata di pioggia - a circa € 800 a bottiglia per Pingus (Q3 2019, certa annata
                        come il 2014 sono molto più alti) e oltre € 400 per Unico, sembra che ciò che Ribera del Duero
                        manca di quantità di vino pregiato, compensa con la qualità.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Ribera del Duero</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Eine dieser Regionen ist Ribera del Duero im Norden des Landes. Die Region liegt in Castilla y Leon, etwa zwei Stunden nördlich von Madrid. Sie ist etwa 70 Meilen lang und verläuft entlang des Flusses Duero. Es verfügt außerdem über ein überraschend halbtrockenes Gelände, während die enormen Unterschiede in Höhe, Boden, Ausrichtung und natürlich im Savoir-faire dazu führen, dass kein Wein dem anderen gleicht. Im Jahr 2012 wurde es außerdem zur Region des Jahres für Weinliebhaber gekürt.
                        <br><br>
                        Nehmen wir zum Beispiel seine beiden Starspieler: Pingus gilt als einer der individuellsten Weine auf dem Markt. Seine Einzigartigkeit ist seine Stärke und wäre in keiner der anderen Weinregionen Spaniens möglich gewesen. Die Tempranillo-Weine aus alten Reben sind groß, kräftig und strukturiert und werden von Pingus‘ Winzer Peter Sisseck, der die Region ins Rampenlicht gerückt hat, mit Sensibilität und Liebe behandelt. Und ja, es ist ein Pingus, einer der perfekten Parker-Zeiger.
                        <br><br>
                        Der andere Superstar der Region ist völlig anders und unterstreicht die enorme Vielfalt
                        Ribera del Duero ist dazu fähig. Das Unico in Vegas Sicilia hat den Traditionalismus der alten Welt beibehalten
                        hat es seit über 150 Jahren zu einem Weltmarktführer gemacht. Seine epischen Ausmaße sind grenzenlos und bieten
                        beispielloses Lagerpotenzial, egal ob Sie ihn trinken oder investieren möchten. Beide Weine sind zu
                        Man sollte ihn sich jedoch für einen regnerischen Tag aufsparen – für rund 800 € pro Flasche für Pingus (3. Quartal 2019, bestimmter Jahrgang).
                        (wie 2014 sind viel höher) und mehr als 400 € für Unico, es scheint das zu sein, was Ribera del Duero
                        Der Mangel an erlesenen Weinen wird durch Qualität wettgemacht.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Ribera del Duero</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        L'une de ces régions est Ribera del Duero, située dans le nord du pays. Située en Castille et Leon, à environ deux heures au nord de Madrid, la région mesure environ 70 miles de long et longe le fleuve Duero. Il a également un terrain étonnamment semi-aride alors que les énormes différences d'altitude, de sol, d'exposition et bien sûr de savoir-faire ne font pas deux vins identiques. Elle a également été nommée région de l'année par Wine Enthusiast en 2012.
                        <br><br>
                        Prenons par exemple ses deux acteurs vedettes : Pingus est considéré comme l'un des vins les plus individuels du marché. Sa singularité fait sa force et n'aurait pas été possible dans l'une des autres régions viticoles d'Espagne. Les vins Tempranillo de vieilles vignes sont gros, audacieux et texturés, et sont traités avec sensibilité et amour par le vigneron de Pingus, Peter Sisseck, qui a braqué les projecteurs sur la région. Et oui, c'est un Pingus est l'un des pointeurs parfaits de Parker.
                        <br><br>
                        L'autre superstar de la région est complètement différente, soulignant la grande variété qui
                        Ribera del Duero en est capable. L'Unico de Vegas Sicilia a conservé le traditionalisme de l'ancien monde qui
                        en a fait un acteur mondial depuis plus de 150 ans. Ses proportions épiques sont illimitées, offrant
                        un potentiel de garde inégalé que vous cherchiez à boire ou à investir. Les deux vins sont à
                        être économisé pour un jour de pluie - à environ 800 € la bouteille pour Pingus (Q3 2019, certains millésimes
                        comme 2014 sont beaucoup plus élevés) et plus de 400 € pour Unico, il semble que ce que Ribera del Duero
                        manque de bon vin en quantité, il se rattrape par la qualité.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Ribera del Duero</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        One such region is Ribera del Duero, located in the north of the country. Found in Castilla y Leon, roughly two hours north of Madrid, the region is approximately 70 miles long and runs along the River Duero. It also has a surprisingly semi-arid terrain while the huge differences in elevation, soil, exposure and of course savoir faire make no two wines the same. It was also named Wine Enthusiast’s Region of the Year in 2012.
                        <br><br>
                        Take for example its two star players: Pingus is considered one of the most individual wines on the market. Its singularity is its strength, and would not have been possible in one of the other wine regions of Spain. The old-vine Tempranillo wines are big, bold and textured, and are treated with sensitivity and love by Pingus’ winemaker Peter Sisseck, who has shone a spotlight on the region. And yes, it’s a Pingus is one of the Parker perfect pointers.
                        <br><br>
                        The other superstar of the region is completely different, underlining the vast variety that
                        Ribera del Duero is capable of. Vegas Sicilia’s Unico has kept the old-world traditionalism that
                        has made it a world-player for over 150 years. Its epic proportions are limitless, offering
                        unparalleled cellaring potential whether you are looking to drink or invest. Both wines are to
                        be saved for a rainy day though - at around €800 a bottle for Pingus (Q3 2019, certain vintage
                        like 2014 are much higher) and upwards of €400 for Unico, it appears that what Ribera del Duero
                        lacks in fine wine quantity, it makes up for with quality.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RiberaDelDuero",
    head: {
        title: 'Ribera del Duero fine wine | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the rich and bold flavors of Ribera del Duero wine region, known for its intense red wines made from the Tempranillo grape. Explore the diverse wine styles and aromas produced by the top wineries in this stunning Spanish wine region.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Please choose', src: '#'},
            items: [
                {report: 'Pingus', src: '/wine-guide/spain/ribera-del-duero/pingus'},
                {report: 'Vega Sicilia', src: '/wine-guide/spain/ribera-del-duero/vega-sicilia'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
